<template>
    <h1>Aqeel Here</h1>
</template>

<script>
 export default {
        name: "Index",
    }
</script>
